import { render, staticRenderFns } from "./CreateInstanceFromContextDetailComponent.vue?vue&type=template&id=f57d2d34&scoped=true&"
import script from "./CreateInstanceFromContextDetailComponent.vue?vue&type=script&lang=js&"
export * from "./CreateInstanceFromContextDetailComponent.vue?vue&type=script&lang=js&"
import style0 from "./CreateInstanceFromContextDetailComponent.vue?vue&type=style&index=0&id=f57d2d34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f57d2d34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VSelect,VTextField})
